// src/Shapes.js
import React from 'react';
import './Shapes.css'; // Подключаем файл стилей для шейпов

const Shapes = () => {
  return (
    <div className="shapes-container">
      <div className="shape first-shape"></div>
      <div className="shape second-shape"></div>
      <div className="shape third-shape"></div>
    </div>
  );
};

export default Shapes;
